import axios from "axios";
import Vue from 'vue'
export const state = {
  Websiteid: null,
};

export const getters = {
  GettersWebsiteid(state) {
    return state.Websiteid;
  },
};

export const mutations = {
  Websiteid(state, Id) { 
    state.Websiteid = Id;
  },
  ClearJWToken() {
    window.$cookies.remove("ecampus",null,Vue.prototype.$config.COOKIES_DOMAIN);  
  },
};

export const actions = {
   WebSite({ commit }, Data) {
    commit("Websiteid", Data);
  },
  //GET
  async ActionsGet(_, Data) {
   
    return axios
      .get(
        Data["Service"] +
          "?PageNumber=" +
          Data["Page"].PageNumber +
          "&PageSize=" +
          Data["Page"].PageSize
      )
      .then((res) => res.data)
      .catch((error) => error.response.data);
  },

  //GET Single
  async ActionsSingleGet(_, Data) {
   
    return axios
      .get(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
  },

  //FİLTER GET
  async ActionsFilterGet(_, Data) {
   
    return axios
      .get(
        Data["Service"] +
          "?PageNumber=" +
          Data["Page"].PageNumber +
          "&PageSize=" +
          Data["Page"].PageSize +
          Data["Filter"]
      )
      .then((res) => res.data)
      .catch((error) => error.response.data);
  },

  //POST
  async ActionsPost(_, Data) {
   
    return axios
      .post(Data["Service"], Data["Data"])
      .then((res) => res.data)
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },

  //PUT
  async ActionsPut(_, Data) {
   
    return axios
      .put(Data["Service"] + "/" + Data["Data"].Id, Data["Data"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  },

  //PUTList
  async ActionsPutList(_, Data) {
   
    return axios
      .put(Data["Service"], Data["Data"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  },

  //DELETE PUT
  async ActionsDeletePut(_, Data) {
   
    return (
      axios
        .put(Data["Service"], {})
        .then((res) => res.data)
        //.catch((error) => error.response.data);
        .catch((error) => {
          console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
        })
    );
  },

  //DELETE
  async ActionsDelete(_, Data) {
   
    return axios
      .delete(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
  },  
  //DELETE PARAMETRE
  async ActionsDeleteParametre(_, Data) {
    return axios
      .delete(Data["Service"] + "?" + Data["Parametre"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
  },

  //SABİTLER
  async ActionsSabitGet(_, Tip) {
   
    return axios
      .get(Vue.prototype.$config.API_URL_2+"OKeyValues?Tip=" + Tip + "&PageNumber=1&PageSize=9999")
      .then((res) => {
        return res.data;
      });
  },

  //FastReport
  async FastReport(_, Data) {
   
    axios({
      url: "GenericReport",
      method: "POST",
      responseType: "blob",
      data: Data,
    })
      .then((response) => {
        //YENİ SEKMEDE AÇMAK İÇİN
        let blob = new Blob([response.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
        window.open(url);
      })
      .catch((error) => error.response.data);
    /* DİREK İNDİRMEK İÇİN 
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a'); 
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'file.pdf');
        document.body.appendChild(fileLink); 
        fileLink.click();
    */
  },
};
